// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2d60f55f","453":"8a8bb660","455":"ed515e13","977":"526a4423"}[chunkId] + ".chunk.js";
};